
import { computed } from 'vue'
import { CImportBase, CImportInformation } from '@invivodf/common/src/contexts/parameters'
import { useI18nForVue2 } from '@invivodf/locales/src/useI18n'
import { useStore } from '../../composables/useStore'
import { electronicInvoicingAddressesService } from '../../services'

const csvFileProperties = {
  name: 'electronic-invoicing-addresses.csv',
  full_path: '/assets/csv/electronic-invoicing-addresses.csv',
}

export default {
  name: 'CImportElectronicInvoicingAddresses',
  components: {
    CImportBase,
    CImportInformation,
  },
  setup() {
    const store = useStore()
    const i18n = useI18nForVue2()

    const distributorId = computed(() => store.getters.cooperativeId)
    const partner = computed(() => store.getters.cooperative)

    const pageTitle = computed(() => i18n.t('ctx.import.electronic-invoicing-addresses__title').toString())
    const importSectionTitle = computed(() =>
      i18n.t('ctx.import.electronic-invoicing-addresses__section-title').toString(),
    )
    const uploadButtonLabel = computed(() =>
      i18n.t('ctx.import.electronic-invoicing-addresses__description').toString(),
    )
    const informationTitle = computed(() =>
      i18n.t('ctx.import.electronic-invoicing-addresses__informations').toString(),
    )
    const exportText = computed(() => i18n.t('ctx.import.electronic-invoicing-addresses__export-action').toString())

    // Aucun compteur n'est exposé pour les codes d'adressage : count à null masque la ligne
    // et ne laisse que le lien d'export.
    const importInformation = computed(() => ({ count: null }))

    function downloadCSV() {
      return electronicInvoicingAddressesService.downloadElectronicInvoicingAddresses(
        distributorId.value,
        partner.value.name,
      )
    }

    return {
      csvProperties: csvFileProperties,
      distributorId,
      downloadCSV,
      electronicInvoicingAddressesService,
      exportText,
      importInformation,
      importSectionTitle,
      informationTitle,
      pageTitle,
      partner,
      uploadButtonLabel,
    }
  },
}
